const getters = {
  name: state => state.user.name,
  entityId: state => state.user.entityId,
  account: state => state.user.account,
  uid: state => state.user.uid,
  role: state => state.user.role,
  smsVerify: state => state.user.smsVerify,
  menus: state => state.user.menus,
  controls: state => state.user.controls,
  loginErrorCount: state => state.user.loginErrorCount,
  apps: state => state.app.apps,
  appisinit: state => state.app.isInit,
  appName: state => state.app.appName,
  currentApp: state => state.app.apps[state.app.index],
  appIndex: state => state.app.index,
  appId: state => state.app.appId,
  appNo: state => state.app.appNo,
  loginSetting: state => state.app.loginSetting,
  nodeEnv: state => state.app.nodeEnv,
  addRouters: state => state.permission.addRouters,
  permission_routers: state => state.permission.routers
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js